import * as Yup from 'yup';
import { DictionaryLawParagraph, DictionaryLaw } from './../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryLawParagraph>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    law: Yup.mixed<DictionaryLaw>().nullable().required('Povinné pole'),
  });
}
